import script from "./HomeHowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./HomeHowItWorks.vue?vue&type=style&index=0&id=6df95136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df95136"]])

export default __exports__